var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.921862 827.371571a148.960931 148.960931 0 0 1-148.960931-148.535328v-106.400665a21.705736 21.705736 0 0 1 21.280133-21.705736 21.705736 21.705736 0 0 1 21.280133 21.280133v106.400665a106.826268 106.826268 0 0 0 106.400665 106.400665h425.60266a105.54946 105.54946 0 0 0 105.975062-106.400665v-106.400665a21.280133 21.280133 0 0 1 21.280133-21.280133 21.280133 21.280133 0 0 1 21.280133 20.85453v106.400665A148.960931 148.960931 0 0 1 723.524522 826.094763H297.921862z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M510.723192 677.985037a21.705736 21.705736 0 0 1-21.280133-21.280133v-383.042394a21.280133 21.280133 0 0 1 21.280133-21.280133 21.280133 21.280133 0 0 1 21.280133 20.854531v383.042394a21.705736 21.705736 0 0 1-21.280133 21.705735z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M329.416459 423.049044a21.280133 21.280133 0 0 1-14.896093-6.38404 21.705736 21.705736 0 0 1 0-30.217789l180.029925-180.88113a22.556941 22.556941 0 0 1 16.172901-6.38404 20.003325 20.003325 0 0 1 14.896093 6.38404L705.64921 385.59601a21.280133 21.280133 0 0 1 0 30.217789 21.280133 21.280133 0 0 1-29.792186 0L510.723192 250.679967l-165.985037 165.985037a21.705736 21.705736 0 0 1-15.321696 6.38404z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e5b797efa33cdcf8063e1af7a035f838.svg";
export { ForwardRef as ReactComponent };